export default "__VITE_ASSET__08c9c539__"